"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggerLink = void 0;
const core_1 = require("@apollo/client/core");
exports.loggerLink = new core_1.ApolloLink((operation, forward) => {
    operation.setContext({ start: new Date().getTime() });
    return forward(operation).map(response => {
        return response;
    });
});
//# sourceMappingURL=loggerLink.js.map